<template>
  <div>
    <!-- <banner></banner> -->
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>域名注册</h2>
        <ul>
          <li>
            <i class="step">1</i>添加清单</li>
          <li>
            <i class="step">2</i>确认订单</li>
          <li>
            <i>3</i>在线支付</li>
          <li>
            <i>4</i>支付成功</li>
        </ul>
      </div>
    </div>

    <div class="grayBg yregister"
         style="padding:20px 0 40px;">
      <div class="regtable"
           v-loading="domainTableIsLoading">

        <table>
          <caption>域名信息
          </caption>
          <tr>
            <th width="16%">域名
            </th>
            <th width="6%">类别</th>
            <th width="30%">时长</th>
            <th width="23%">服务</th>
            <th width="19%">费用</th>
            <th width="6%">操作</th>
          </tr>
          <tr v-for="(item,i) in cartGroupList"
              :key="i">
            <td>{{item.domainInputInfo.domainName}}{{item.domainInputInfo.domainSuffix}}</td>
            <td>转入</td>

            <td class="year">
              <div class="year-pre"
                   :class="{disabled:item._yearIndex>=0}"
                   @click="item._yearIndex<0&&item._yearIndex++"></div>
              <div class="year-wrap">
                <ul :style="{width:item.domainInputInfo.domainMaxTimeLong*50+'px',left:item._yearIndex*50+'px'}">
                  <li :class="{yearCur:n==item.timeLong}"
                      v-for="(n,i) in item.domainInputInfo.domainMaxTimeLong"
                      :key="i"
                      @click="item.timeLong=n,update(item)">{{i+1}}年</li>
                </ul>
              </div>
              <div class="year-next"
                   :class="{disabled:item._yearIndex<=-(item.domainInputInfo.domainMaxTimeLong-5)}"
                   @click="item._yearIndex>-(item.domainInputInfo.domainMaxTimeLong-5)&&item._yearIndex--"></div>
            </td>
            <td>--</td>
            <td class="cost">
              <!-- {{item}} -->
              <i>¥{{item.sumPrice}}</i>
              <em class="cost-price"
                  v-if="item.promotions">(原价：¥{{item.currentPrice}})</em>
            </td>
            <td class="delete"
                @click="del(item)">删除</td>
          </tr>

        </table>
      </div>
      <div class="total ">
        <p>总价费用：
          <i v-if="cartGroupList.length == 0">--</i>
          <i v-else>￥{{cartInfoVO&&cartInfoVO.deaiMoney}}</i>
        </p>
        <el-button :loading="nextButtonIsLoading"
                   :disabled="cartInfoVO&&cartInfoVO.deaiMoney==='--' || cartGroupList.length == 0"
                   style="padding:0;border-radius:0"
                   class="transform-btn"
                   :class="{nextCur:acceptAgreement}"
                   type="primary"
                   @click="settlements">提交订单</el-button>
      </div>
    </div>

  </div>
</template>
<script>
import banner from './components/header'
import recommend from './components/recommend'
import cTitle from './components/title'
import protocolDomain from './components/Protocol-domain'

export default {
  data () {
    return {
      nextButtonIsLoading: false,
      domainTableIsLoading: false,
      isAcceptDomainTreaty: false,
      cartInfoVO: {
        deaiMoney: '--'
      },
      serviceGoodsList: [],
      cartGroupList: [],
      selectedPromotions: [],
      templateList: [],
      domainTemplateId: '',
      isShowTemplateForm: false,
      acceptAgreement: false,
      form: {
        registrantType: 'E',
        nameCn: '',
        nameEn: '',
        email: '',
        source: '3'
      }
    }
  },
  components: {
    banner,
    recommend,
    cTitle,
    protocolDomain
  },
  destroyed () {
    window.sessionStorage.removeItem("domainTransformCache")
  },
  methods: {
    del (item) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          for (let i = 0; i < this.cartGroupList.length; i++) {
            if (this.cartGroupList[i].skuId === item.skuId) {
              this.cartGroupList.splice(i, 1)

              window.sessionStorage.setItem("domainTransformCache", JSON.stringify(this.cartGroupList))
              if (this.cartGroupList.length != 0) {
                this.update()
              }
              return
            }
          }
        })
        .catch(() => { })
    },
    update (item) {
      if (item) {
        item.sumPrice = '--'
        item.currentPrice = '--'
      }

      this.cartInfoVO.deaiMoney = '--'

      $.post(`${__shopURL}/order/settlements1`, {
        data: JSON.stringify(this.cartGroupList)
      }).then(response => {
        this.nextButtonIsLoading = false
        if (!response || !response.orderStatement) {
          this.$message({
            type: 'error',
            message: response.msg || '错误'
          })
          return
        }
        this.cartInfoVO.deaiMoney = response.orderStatement.totalAmount
        this.selectedPromotions = response.orderStatement.promotions || []
        console.log(this.selectedPromotions)
        response.orderStatement.orderStatementItemList.forEach(ele => {
          this.cartGroupList.forEach(cele => {
            if ((ele.domainName == cele.domainInputInfo.domainName) && (ele.domainSuffix == cele.domainInputInfo.domainSuffix)) {
              this.$set(cele, 'promotions', ele.promotions)
              this.$set(cele, 'sumPrice', ele.sumPrice)
              this.$set(cele, 'currentPrice', ele.currentPrice)
              this.$set(cele, 'basePrice', ele.basePrice)
              this.$set(cele, 'goodsId', ele.goodsId)
            }
          })

        })

      })
    },

    settlements () {
      let postData = {
        "promotions": [],
        "source": 2,
        "orderDeatil": []
      }
      this.selectedPromotions.forEach((e, i) => {
        postData.promotions.push({
          id: e.id
        })
      })
      this.cartGroupList.forEach(ele => {
        postData.orderDeatil.push({
          "skuId": ele.skuId,
          "goodsId": ele.goodsId,
          "timeFlag": false,
          "NUM": 1,
          "TIME_LONG": ele.timeLong,
          "LANGUAGE": ele.LANGUAGE,
          "domainInputInfo": {
            "DOMAIN_NAME": ele.domainInputInfo.domainName,
            "DOMAIN_SUFFIX": ele.domainInputInfo.domainSuffix,
            "DOMAIN_TEMPLATE_ID": ele.domainInputInfo.domainTemplateId,
            "DOMAIN_TRANSFER_TYPE": 1,
            "DOMAIN_TRANSFER_PWD": ele.domainInputInfo.domainPassword,
            "DOMAIN_MODIFY_DNS": 0
          }

        })
      })
      $.post(`${__shopURL}/order/savecommonorders`, {
        data: JSON.stringify(postData)
      }).then(
        response => {
          if (!response || !response.orderid) {
            this.$message({
              type: 'error',
              message: response.msg || '错误'
            })
            return
          }
          window.location.href = window.location.protocol + '//' + window.location.host + `/payment/index.html?orderid=${response.orderid}`

        },
        error => {
          this.domainTableIsLoading = false
          this.$msgbox({
            type: 'error',
            message: '服务器忙！请稍后再试！'
          })
        }
      )
    },
    initCartsList () {
      this.cartGroupList = JSON.parse(window.sessionStorage.getItem('domainTransformCache'))
      this.cartGroupList.forEach(ele => {
        this.$set(ele, '_yearIndex', 0)
      })

    }
  },

  created () {
    this.initCartsList()
    if (this.cartGroupList.length > 0) {
      this.update()
    } else {
      this.$message({
        type: 'error',
        message: '没有商品数据'
      })
    }

  }
}
</script>

<style  lang="scss">
@import "../static/css/register.scss";
</style>



// WEBPACK FOOTER //
// src/domain-transform-register.vue